/**
 * 文字数チェック用
 */
// 最小文字数
// パスワード
export const minLengthOfPassword = 8;
// 表示順
export const minLengthOfDisplayOrderString = -2147483648;
// 最大文字数
// 認証コード
export const maxLengthOfAuthenticationCode = 6;
// 企業ID
export const maxLengthOfCompanyId = 32;
// ユーザーID
export const maxLengthOfUserId = 20;
// パスワード
export const maxLengthOfPassword = 25;
// 家族・企業パスワード
export const maxLengthOfFamilyCompanyPassword = 160;
// メールアドレス
export const maxLengthOfMailAddress = 254;
// 電話番号
export const maxLengthOfTelNumber = 20;
// 短文文字列。姓・名・続柄など
export const maxLengthOfShortString = 64;
// 文字列。問診・アンケート項目など
export const maxLengthOfString = 128;
// 長文文字列。連絡メッセージなど
export const maxLengthOfLongString = 2000;
// キーワード
export const maxLengthOfKeywordString = 256;
// 管理名など（組織マスタ、勤務地マスタ用）
export const maxLengthOfManagementLongNameString = 100;
// 管理名など（組織マスタ・勤務地マスタ以外の属性マスタ用。例：職種マスタや時間外労働時間マスタなど）
export const maxLengthOfManagementShortNameString = 50;
// 表示順
export const maxLengthOfDisplayOrderNumber = 2147483647;
// 連絡先設定画面の部署や、氏名、電話番号の文字数
export const maxLengthOfSettingCurrentString = 256;
// 連絡先設定画面のメールアドレスの文字数
export const maxLengthOfSettingMailAddressString = 1024;

/**
 * 記号の入力不正チェック用の基本構文
 */
// 許可する記号は、「/」「*」「?」「>」「<」「:」「"」「|」「.」「 」(半角スペース)
export const matchPatternSymbolGroup1 = '\\/\\*\\?\\>\\<\\:\\"\\|\\.\\s';

// 許可する記号は、「!」「#」「$」「%」「&」「'」「(」「)」「+」「-」「;」「=」「@」「[」「\」「]」「^」「_」「`」「{」「}」「~」
export const matchPatternSymbolGroup2 = "\\!\\#\\$\\%\\&\\'\\(\\)\\+\\-\\;\\=\\@\\[\\\\\\]\\^\\_\\`\\{\\}\\~";

// 許可する記号は、「^ $ * . [ ] { } ( ) ? " ! @ # % & / \ , > < ' : ; | _ ~ ` = + -」
export const cognitoSymbol = '\\^\\$\\*\\.\\[\\]\\{\\}\\(\\)\\?\\"\\!\\@\\#\\%\\&\\/\\\\,\\>\\<\\:\\;\\|\\_\\~\\`\\=\\+\\-' + "\\'";

/**
 * 入力不正チェック用
 */
// 0～9の数字
export const matchPatternNumber = '^[0-9]+$';
// 半角英数字
export const matchPatternAlphabetNumber = '^[a-zA-Z0-9]+$';
// 半角英数小文字
export const matchPatternLowerAlphabetNumber = '^[a-z0-9]+$';
// 半角英数記号
export const matchPatternAlphabetNumberSymbol = '^[a-zA-Z0-9!-/:-@[-`{-~]+$';
// 電話番号。半角数字＋「-(ハイフン)」のみ許容
export const matchPatternTelNumber = '^(?=.*[0-9])(?=.*-)[0-9-]{2,}$';

// メールアドレス
export const matchPatternMailAddress = '^([\\w!#$%&\'*+/=?^_`{|}~-]+(?:\\.[\\w!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)+$';
//export const matchPatternMailAddress = '^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]+.[A-Za-z0-9]+$';

// 姓（セイ）・名（メイ）。全角カナ＋全角英数字＋全角記号のみ許容
export const matchPatternKana = '^[ァ-ンヴー０-９Ａ-Ｚａ-ｚ　！”＃＄％＆’（）＊＋，―．／：；＜＝＞？＠［＼］＾＿｀｛｜｝〜]+$';

// 半角英数混合。英字小文字もしくは大文字1文字以上＋数字1文字以上
export const matchPatternAlphabetNumberMix = '^(?=.*[a-zA-Z])(?=.*[0-9])[a-zA-Z0-9]+$';

// IPアドレス。IPv4アドレス形式(xxx.xxx.xxx.xxx)またはIPv4 CIDR形式(xxx.xxx.xxx.xxx/nn) ※xxx：0～255、nn:0-32
export const matchIpAddress = '^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9]).){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9]?[0-9])(/([0-9]|[12][0-9]|3[0-2]))?$';

// 各マスタ管理のID項目の入力パターンをチェックする。
// 許容する記号：pattern1
export const matchPatternManagementId = '^[a-zA-Z0-9' + matchPatternSymbolGroup1 + ']+$';

// 各マスタ管理の英語名称の入力パターンをチェックする。
// 許容する記号：pattern1とpattern2
export const matchPatternManagementNameEn = '^[a-zA-Z0-9' + matchPatternSymbolGroup1 + matchPatternSymbolGroup2 + ']+$';

// 半角英数記号の混合。英字小文字もしくは大文字1文字以上＋数字1文字以上＋記号。
export const matchPatternAlphabetNumberSymbolMix = '^(?=.*[a-zA-Z])(?=.*[0-9])(?=.*[' + cognitoSymbol + '])[a-zA-Z0-9' + cognitoSymbol + ']+$';

export default {
    minLengthOfPassword,
    maxLengthOfCompanyId,
    maxLengthOfUserId,
    maxLengthOfPassword,
    maxLengthOfAuthenticationCode,
    maxLengthOfFamilyCompanyPassword,
    maxLengthOfMailAddress,
    maxLengthOfTelNumber,
    maxLengthOfShortString,
    maxLengthOfString,
    maxLengthOfLongString,
    maxLengthOfKeywordString,
    matchPatternNumber,
    matchPatternAlphabetNumber,
    matchPatternLowerAlphabetNumber,
    matchPatternAlphabetNumberSymbol,
    matchPatternTelNumber,
    matchPatternMailAddress,
    matchPatternKana,
    maxLengthOfManagementLongNameString,
    maxLengthOfManagementShortNameString,
    maxLengthOfDisplayOrderNumber,
    matchPatternManagementId,
    matchPatternManagementNameEn,
    matchPatternAlphabetNumberMix,
    matchIpAddress,
    minLengthOfDisplayOrderString,
    maxLengthOfSettingCurrentString,
    maxLengthOfSettingMailAddressString,
    matchPatternAlphabetNumberSymbolMix
};
